import { html } from 'lit';

export default html`
<svg height="10" viewBox="0 0 13 10" width="13" xmlns="http://www.w3.org/2000/svg">
    <path
        d="m4.33333333 10-4.33333333-4.16666667 1.73333333-1.66666666 2.6 2.5 6.93333337-6.66666667 1.7333333 1.66666667z"
        fill="#fff" fill-rule="evenodd" />
</svg>
`;
